import { Button } from "@mui/material";
import React from "react";
import Ajax from "../../../Ajax";
import { store } from "../../../stores/Store";
import { Alert } from "../../..";

export default function UserPasswordUpdateInvite ({userUid}) {

    const [user, setUser] = React.useState(null)
    const [submitting, setSubmitting] = React.useState(false)
    const [errorMessage, setErrorMessage] = React.useState(null)

    React.useEffect(() => {
        Ajax.Node.Get(userUid).then((response) => {
            setUser(response.data)
        })
    }, [])

    const submit = async () => {
        setSubmitting(true)
        setErrorMessage(null)
        
        await Ajax.Session.SendPasswordUpdateInvite(user.uid).then(() => {
            store.AlertStore.Close()
        }).catch((response) => {
            setErrorMessage(response.data?.detail ? response.data.detail : "Invite failed")
        })
        
        setSubmitting(false)
    }

    if (!user) return <p>Loading user...</p>

    return (
        <div className="form">
            <h2>Send Password Update Invitation</h2>

            <p>An email will be sent to <b>{user.email}</b> containing a link which will allow them so sign in and update their password.</p>

            {errorMessage ? (
                <div className="warning">
                    {errorMessage}
                </div>
            ) : null}

            <div className="form-buttons">
                <Button disabled={submitting} className="btn btn-sm" onClick={() => store.AlertStore.Close()}>
                    Cancel
                </Button>
                
                <Button disabled={submitting} className="btn btn-sm" color="success" variant="contained" onClick={() => submit()}>
                    Confirm and send invite
                </Button>
            </div>
        </div>
    )
}